// SPEC-099: the optional newsletter opt-in shown wherever an account is
// created. The backend stores the exact sentence from its own settings,
// keyed by this version: change the copy → bump the version there too.
export const ACCOUNT_CONSENT_TEXT_VERSION = '2026-10-account'

// SPEC-099 D9 / SPEC-101 D2 (Nate + Matt): the short text. Nothing on
// production has recorded consent yet, so 2026-10-account takes this text.
export const NEWSLETTER_CONSENT_LABEL =
  'Send me the free weekly newsletter and occasional offers. Unsubscribe anytime.'
export const PRIVACY_POLICY_URL =
  'https://www.stanwinstonschool.com/customer-care/privacy-policy/'

// The fields an account-creation request carries. Only a surface that shows
// the box has an answer (true or false); everywhere else (LoginBox, OTP…)
// nothing is sent, so the backend treats the account as not consenting.
export const accountConsentPayload = (marketingConsent) =>
  typeof marketingConsent === 'boolean'
    ? {
        marketingConsent,
        consentTextVersion: ACCOUNT_CONSENT_TEXT_VERSION
      }
    : {}

// The same answer for analytics (PostHog / GA4), when there is one
export const accountConsentEventProps = (marketingConsent) =>
  typeof marketingConsent === 'boolean'
    ? { marketing_consent: marketingConsent }
    : {}
